import { render, staticRenderFns } from "./createServicos.vue?vue&type=template&id=b2772a3a&scoped=true&"
import script from "./createServicos.vue?vue&type=script&lang=js&"
export * from "./createServicos.vue?vue&type=script&lang=js&"
import style0 from "./createServicos.vue?vue&type=style&index=0&id=b2772a3a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2772a3a",
  null
  
)

export default component.exports